import classNames from 'classnames'
import React, { FC } from 'react'

import s from './WixMobileFooter.scss'

interface WixMobileFooterProps {
  skin?: 'new-funnel' | 'standard'
}

export const WixMobileFooter: FC<WixMobileFooterProps> = ({ children, skin = 'standard' }) => {
  return (
    <footer
      className={classNames(s.footer, { [s.newFunnel]: skin === 'new-funnel', [s.standard]: skin === 'standard' })}
    >
      {children}
    </footer>
  )
}
